import { Injectable } from '@angular/core';
import { EnvConfigurationService } from './envconf.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ReplPlan } from '../models/forecast/replPlan';

@Injectable({
  providedIn: 'root'
})
export class ForecastService {
  endpoint: string = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/forecast`;

  /**
   * Constructor
   *
   * @param http httpClient
   *  @param apiService apiService
   */
  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  /**
   * Ask the backend the available size for given site
   * @param idUser the query user
   * @param siteId the desired site
   */
  getAllSizeFull(idUser: number, siteId: number): Observable<string[]> {
    return this.http.get<Array<string>>(`${this.endpoint}/sizes?idUser=${idUser}&siteId=${siteId}`);
  }

  /**
   * Ask the backend to generate a ReplPlan for given parameters
   * @param idUser the query user
   * @param siteId the site
   * @param sizeFull the desired size
   * @param fromYear year from start the ReplPlan
   * @param fromMonth month from start the ReplPlan
   */
  getReplPlan(idUser: number, siteId: number, sizeFull: string, fromYear: number, fromMonth: number): Observable<ReplPlan> {
    return this.http.get<ReplPlan>(
      `${this.endpoint}?idUser=${idUser}&siteId=${siteId}&size=${sizeFull}&fromYear=${fromYear}&fromMonth=${fromMonth}`
    );
  }

  /**
   * Ask the backend to recalculate a ReplPlan from given replPlan
   * @param idUser the query user
   * @param siteId the site
   * @param sizeFull the desired size
   * @param replPlan ReplPlan lines to recalculate
   */
  reCalculateReplPlan(idUser: number, siteId: number, sizeFull: string, replPlan: ReplPlan): Observable<ReplPlan> {
    return this.http.put<ReplPlan>(`${this.endpoint}/recalculate?idUser=${idUser}&siteId=${siteId}`, {
      sizeFull: sizeFull,
      lines: replPlan.replPlanSpecLines
    });
  }

  /**
   * Ask the backend to save a ReplPlan for given parameters
   * @param idUser the query user
   * @param siteId the site
   * @param sizeFull the desired size
   * @param replPlan ReplPlan lines to save
   */
  saveReplPlan(idUser: number, siteId: number, sizeFull: string, replPlan: ReplPlan) {
    return this.http.put(`${this.endpoint}?idUser=${idUser}&siteId=${siteId}`, {
      sizeFull: sizeFull,
      lines: replPlan.replPlanSpecLines
    });
  }

  /**
   * Copy all proposed replenishments and recalculate month per month the next right proposed replenishment to apply to follow param rules
   * @param idUser the query user
   * @param siteId the site
   * @param sizeFull the desired size
   * @param replPlan ReplPlan lines to copy
   */
  copyAllProposedRepl(idUser: number, siteId: number, sizeFull: string, replPlan: ReplPlan): Observable<ReplPlan> {
    return this.http.put<ReplPlan>(`${this.endpoint}/copy-all-proposed-repl?idUser=${idUser}&siteId=${siteId}`, {
      sizeFull: sizeFull,
      lines: replPlan.replPlanSpecLines
    });
  }

  /**
   * Copy one spec proposed replenishments and recalculate month per month the next right proposed replenishment to apply to follow param rules
   * @param idUser the query user
   * @param siteId the site
   * @param specToCopy the spec to copy
   * @param sizeFull the desired size
   * @param replPlan ReplPlan lines to copy
   */
  copyOneSpecProposedRepl(idUser: number, siteId: number, specToCopy: number, sizeFull: string, replPlan: ReplPlan): Observable<ReplPlan> {
    return this.http.put<ReplPlan>(
      `${this.endpoint}/copy-one-spec-proposed-repl?idUser=${idUser}&siteId=${siteId}&specToCopy=${specToCopy}`,
      {
        sizeFull: sizeFull,
        lines: replPlan.replPlanSpecLines
      }
    );
  }
}
